import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";

import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";

import { ChildPropsFromPagination } from "types/commons";
import { SortDirection } from "__generated__/enums";
import { GetShipsForSelectDocument, GetShipsForSelectQuery, GetShipsForSelectQueryVariables } from "__generated__/view/ships/graphql/ship.queries.generated";

export type ShipSelectOption = ChildPropsFromPagination<GetShipsForSelectQuery, "ships">;

const ShipSelect = <Multiple extends boolean = false,>({
	additionalSearchOptions = {},
	...rest
}: Omit<SelectProps<ShipSelectOption, Multiple>, "fetchOptions" | "paginated"> & {
	additionalSearchOptions?: NonNullable<GetShipsForSelectQueryVariables["search"]>;
}) => {

	const client = useApolloClient();

	const onFetchOptions = async(params: string, page: number) => {

		try  {
			const result = await client.query({
				query: GetShipsForSelectDocument,
				variables: {
					search: {
						name: params,
						...additionalSearchOptions,
					},
					pagination: {
						page: page - 1,
						sortList: [ {
							field: "name",
							direction: SortDirection.Asc,
						} ],
						size: 10,
					},
				},
			});

			return {
				options: result.data.ships.content,
				totalResults: result.data.ships.totalElements || 0,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			paginated
			typeToSearchLabel={intl.formatMessage({ id: "TYPE_TO_SEARCH" })}
			loadingLabel={intl.formatMessage({ id: "LOADING_DATA" })}
			getOptionLabel={(option) => `${option.name} ${option.eni ? `(${option.eni})` : ""}`}
			popoverHeight={300}
			{...rest} />
	);
};

export default ShipSelect;
